import { render } from "./FeaturesSection.vue?vue&type=template&id=015bdc93&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&lang=js"

import "./FeaturesSection.vue?vue&type=style&index=0&id=015bdc93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015bdc93"]])

export default __exports__